import { Smartphone, Gift, CreditCard, TrendingUp, BarChart2 } from "lucide-react";

const steps = [
  {
    number: "01",
    icon: Smartphone,
    title: "Pick a plan",
    body: "Choose from plans starting at $7.99/mo. Sign up in minutes — no credit check required to get started.",
  },
  {
    number: "02",
    icon: Gift,
    title: "Activate your free credit builder",
    body: "Every Perch plan includes access to credit building tools. Takes just minutes to get started — at no extra cost.",
  },
  {
    number: "03",
    icon: CreditCard,
    title: "Pay your phone bill",
    body: "Stay on top of your payments like you normally would. Perch helps turn your payment activity into progress toward your financial goals.",
  },
  {
    number: "04",
    icon: TrendingUp,
    title: "Join millions who are ready to start",
    body: "Millions of Americans are building credit for the first time. Perch helps you take that first step — and keep moving forward.",
  },
];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="w-full py-16 lg:py-24 border-t" style={{ backgroundColor: '#1e1e1e', borderColor: 'rgba(255,255,255,0.08)' }}>
      <div className="container mx-auto px-4" style={{ maxWidth: '1200px' }}>

        {/* Header */}
        <div className="text-center mb-12 lg:mb-16">
          <p
            className="font-semibold uppercase mb-4"
            style={{ color: '#B0F18D', fontSize: '13px', letterSpacing: '0.15em' }}
          >
            How It Works
          </p>
          <h2
            className="text-white font-bold mb-4"
            style={{
              fontSize: 'clamp(32px, 5vw, 60px)',
              lineHeight: 1.1,
              letterSpacing: '-0.04em',
            }}
          >
            Your phone bill, working harder.
          </h2>
          <p
            className="mx-auto"
            style={{
              color: 'rgba(255,255,255,0.65)',
              fontSize: 'clamp(15px, 2vw, 18px)',
              lineHeight: 1.6,
              maxWidth: '580px',
            }}
          >
            Most providers stop at connectivity. Perch goes further—giving you tools that help turn everyday payments into real financial progress.
          </p>
        </div>

        {/* 2x2 Card Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
          {steps.map(({ number, icon: Icon, title, body }) => (
            <div
              key={number}
              className="relative flex flex-col p-6 pb-10 rounded-2xl border"
              style={{
                backgroundColor: 'rgba(255,255,255,0.03)',
                borderColor: 'rgba(255,255,255,0.1)',
              }}
            >
              <div
                className="flex items-center justify-center w-10 h-10 rounded-xl mb-4"
                style={{ backgroundColor: 'rgba(176,241,141,0.12)' }}
              >
                <Icon className="w-5 h-5" style={{ color: '#B0F18D' }} />
              </div>
              <h3
                className="text-white font-bold mb-2"
                style={{ fontSize: 'clamp(16px, 1.5vw, 20px)', letterSpacing: '-0.02em' }}
              >
                {title}
              </h3>
              <p style={{ color: 'rgba(255,255,255,0.65)', fontSize: '14px', lineHeight: 1.6 }}>
                {body}
              </p>
              <span
                className="absolute bottom-4 left-6 font-bold"
                style={{ color: 'rgba(255,255,255,0.15)', fontSize: '13px' }}
              >
                {number}
              </span>
            </div>
          ))}
        </div>

        {/* Bottom Highlight Card */}
        <div
          className="flex items-start gap-4 p-6 rounded-2xl border"
          style={{
            backgroundColor: 'rgba(255,255,255,0.03)',
            borderColor: 'rgba(255,255,255,0.1)',
          }}
        >
          <div
            className="flex items-center justify-center w-10 h-10 rounded-xl flex-shrink-0 mt-1"
            style={{ backgroundColor: 'rgba(176,241,141,0.12)' }}
          >
            <BarChart2 className="w-5 h-5" style={{ color: '#B0F18D' }} />
          </div>
          <p style={{ color: 'rgba(255,255,255,0.85)', fontSize: '15px', lineHeight: 1.6 }}>
            <strong className="text-white">Payment history is one of the biggest factors in your credit score.</strong>{' '}
            Perch helps you build consistency and turn everyday payments into forward momentum.
          </p>
        </div>

      </div>
    </section>
  );
};

export default HowItWorks;
